import { useCallback, useEffect, useState } from "react";

const getHash = () =>
  typeof window !== "undefined"
    ? decodeURIComponent(window.location.hash.substring(1))
    : "";

export const useHash = (defaultHash: string = "") => {
  const [hash, setHash] = useState(getHash());

  const handleHashChange = useCallback(() => {
    setHash(getHash());
  }, []);

  const updateHash = useCallback((newHash: string) => {
    window.location.hash = newHash;
  }, []);

  useEffect(() => {
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (defaultHash && !window.location.hash) {
      updateHash(defaultHash);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [hash == "" ? defaultHash : hash, updateHash] as const;
};
